// Initialize form handlers for both Turbo and Turbolinks
import { DateTime } from "luxon";

function initializeInformingForm() {
  console.log("Initializing informing form...");

  // Check if we're on an informing form page (new or edit)
  const formElement = document.querySelector(
    'form[id^="new_informing"], form[id^="edit_informing"]'
  );

  if (formElement) {
    console.log("Informing form detected:", formElement.id);

    // Quick actions for air alerts
    const date = new Date();
    let prepareMintues =
      (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();

    const titleUk = document.getElementById("informing_title_uk");
    const bodyUk = document.getElementById("informing_body_uk");
    const titleEn = document.getElementById("informing_title_en");
    const bodyEn = document.getElementById("informing_body_en");
    const notificationType = document.getElementById(
      "informing_notification_type"
    );

    const airAlertBtn = document.getElementById("informing-air-alert");
    const rejectedAirAlertBtn = document.getElementById(
      "informing-rejected-air-alert"
    );

    if (airAlertBtn) {
      airAlertBtn.addEventListener("click", () => {
        const timeStr = date.getHours() + ":" + prepareMintues;

        // Ukrainian
        if (titleUk)
          titleUk.value =
            "❗️❗️УВАГА Умань повітряна тривога❗️❗️(" + timeStr + ")";
        if (bodyUk)
          bodyUk.value =
            'Зберігайте спокій та знайдіть найближче бомбосховище. Список можна знайти у "Каталозі" ("В єднанні сила")';

        // English
        if (titleEn)
          titleEn.value =
            "❗️❗️ATTENTION Uman Air Raid Alert❗️❗️(" + timeStr + ")";
        if (bodyEn)
          bodyEn.value =
            'Stay calm and find the nearest bomb shelter. You can find the list in the "Catalog" ("Unity is Strength")';

        if (notificationType) {
          notificationType.value = "air_raid_alarm";
        }
      });
    }

    if (rejectedAirAlertBtn) {
      rejectedAirAlertBtn.addEventListener("click", () => {
        const timeStr = date.getHours() + ":" + prepareMintues;

        // Ukrainian
        if (titleUk) titleUk.value = "🟢 Відбій тривоги 🟢(" + timeStr + ")";
        if (bodyUk)
          bodyUk.value =
            "Не поспішайте покидати укриття, почекайте хвилин 20. І пам'ятайте: кожна повітряна тривога, яка не закінчується авіаударам, - це робота наших ЗСУ!🇺🇦";

        // English
        if (titleEn) titleEn.value = "🟢 All Clear 🟢(" + timeStr + ")";
        if (bodyEn)
          bodyEn.value =
            "Don't rush to leave the shelter, wait about 20 minutes. And remember: every air raid alert that doesn't end with an airstrike is the work of our Armed Forces!🇺🇦";

        if (notificationType) {
          notificationType.value = "air_raid_alarm_clear";
        }
      });
    }

    // Action data field handler
    const actionTypeSelect = document.getElementById("action_type_select");
    const actionDataRouteSelect = document.getElementById(
      "action_data_route_select"
    );
    const actionDataUrlInput = document.getElementById("action_data_url_input");
    const actionDataHint = document.getElementById("action_data_hint");

    if (
      actionTypeSelect &&
      actionDataRouteSelect &&
      actionDataUrlInput &&
      actionDataHint
    ) {
      function updateActionDataField() {
        const selectedType = actionTypeSelect.value;

        // Hide all inputs and disable them (so they don't submit)
        actionDataRouteSelect.style.display = "none";
        actionDataRouteSelect.disabled = true;
        actionDataUrlInput.style.display = "none";
        actionDataUrlInput.disabled = true;

        if (selectedType === "navigate_to_page") {
          actionDataRouteSelect.style.display = "block";
          actionDataRouteSelect.disabled = false;
          // Clear the URL input when switching to route select
          actionDataUrlInput.value = "";
          actionDataHint.textContent =
            "Оберіть маршрут із списку доступних сторінок мобільного додатку";
        } else if (selectedType === "open_url") {
          actionDataUrlInput.style.display = "block";
          actionDataUrlInput.disabled = false;
          // Clear the route select when switching to URL input
          actionDataRouteSelect.value = "";
          actionDataHint.textContent =
            "Введіть повне посилання (https://...) або deep link (umanlive://...)";
        } else {
          // Clear both when no action type selected
          actionDataRouteSelect.value = "";
          actionDataUrlInput.value = "";
          actionDataHint.textContent = "Оберіть тип дії вище";
        }
      }

      actionTypeSelect.addEventListener("change", updateActionDataField);

      // Initialize on page load
      updateActionDataField();
    }

    // Auto-detect and set timezone from browser using Luxon
    const timezoneSelect = document.getElementById("informing_timezone");

    if (timezoneSelect && !timezoneSelect.disabled) {
      // Get browser timezone using Luxon
      const now = DateTime.now();
      const browserTimezone = now.zoneName;
      const browserOffset = now.offsetNameShort;
      const browserOffsetFormatted = now.toFormat("ZZ"); // e.g., "+02:00"

      console.log("Detected browser timezone:", browserTimezone);
      console.log("Timezone offset:", now.offset, "minutes");
      console.log("Timezone offset formatted:", browserOffsetFormatted);
      console.log("Timezone offset name:", browserOffset);

      // Check if this is a new form (new_informing) or edit form (edit_informing)
      const isNewForm = formElement.id.startsWith("new_informing");
      const currentValue = timezoneSelect.value;

      // Auto-set timezone if: it's a new form, or current value is Europe/Kiev default
      const shouldAutoSet = isNewForm || currentValue === "Europe/Kiev";

      if (shouldAutoSet) {
        let matchFound = false;

        // First, try to match by IANA name (most accurate)
        for (let i = 0; i < timezoneSelect.options.length; i++) {
          const option = timezoneSelect.options[i];
          const ianaName = option.getAttribute("data-iana-name");

          if (ianaName === browserTimezone) {
            timezoneSelect.value = option.value;
            console.log(
              "✓ Auto-set timezone by IANA:",
              option.text,
              "(",
              browserTimezone,
              ")"
            );
            matchFound = true;
            break;
          }
        }

        // If no IANA match, try UTC offset as fallback
        if (!matchFound) {
          for (let i = 0; i < timezoneSelect.options.length; i++) {
            const option = timezoneSelect.options[i];
            const utcOffset = option.getAttribute("data-utc-offset");

            if (utcOffset === browserOffsetFormatted) {
              timezoneSelect.value = option.value;
              console.log(
                "✓ Auto-set timezone by UTC offset:",
                option.text,
                "(",
                browserOffsetFormatted,
                ")"
              );
              matchFound = true;
              break;
            }
          }
        }

        if (!matchFound) {
          console.log(
            "⚠ Browser timezone not found in select options:",
            browserTimezone,
            "UTC offset:",
            browserOffsetFormatted,
            "- keeping default"
          );
        }
      } else {
        console.log(
          "ℹ Timezone already set to:",
          currentValue,
          "- keeping existing value"
        );
      }
    }
  }
}

// Support both Turbo (modern) and Turbolinks (legacy)
document.addEventListener("turbo:load", initializeInformingForm);
document.addEventListener("turbolinks:load", initializeInformingForm);
document.addEventListener("DOMContentLoaded", initializeInformingForm);

console.log("Informing form script loaded");
